import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()

export class SessionInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let session: string = '';
    if (sessionStorage.getItem('session')) {
      session = sessionStorage.getItem('session') as string;
    } else {
      sessionStorage.setItem('session', this._guid());
      session = sessionStorage.getItem('session') as string;
    }
    request = request.clone({
      setHeaders: {
        'X-Parent-Domain': window.location.origin,
        'session': session
      }
    });

    return next.handle(request);
  }

  private _guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }
}
